import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { seoPages } from "../data/seoPages";

const SITE_URL = "https://www.subtitletsunami.com";

const BlogIndex = () => {
  const blogPosts = seoPages.filter((page) => page.type === "blog");

  return (
    <>
      <SEO
        title="SubtitleTsunami Blog | Spanish Subtitle Guides"
        description="Guides for adding Spanish subtitles to English videos, YouTube Shorts, TikTok videos, Instagram Reels, and more."
        canonical={`${SITE_URL}/blog`}
        image={`${SITE_URL}/og-image.png`}
        type="website"
      />

      <main className="min-h-screen bg-slate-950 px-4 py-12 text-white">
        <section className="mx-auto max-w-5xl">
          <div className="mb-10 rounded-3xl border border-cyan-300/20 bg-slate-900/80 p-6 shadow-2xl shadow-cyan-950/30 md:p-10">
            <p className="mb-4 text-sm font-bold uppercase tracking-[0.3em] text-cyan-300">
              SubtitleTsunami Blog
            </p>

            <h1 className="mb-5 text-4xl font-black leading-tight text-white md:text-5xl">
              Spanish Subtitle Guides for Video Creators
            </h1>

            <p className="max-w-3xl text-lg leading-8 text-slate-300">
              Learn how to add Spanish subtitles to English videos, translate
              short-form content, and create more useful videos for
              Spanish-speaking viewers.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2">
            {blogPosts.map((post) => (
              <Link
                key={post.slug}
                to={post.canonicalPath}
                className="rounded-3xl border border-white/10 bg-slate-900 p-6 transition hover:-translate-y-1 hover:border-cyan-300/40 hover:bg-slate-900/80"
              >
                <p className="mb-3 text-sm font-bold uppercase tracking-[0.2em] text-cyan-300">
                  Guide
                </p>

                <h2 className="mb-3 text-2xl font-black text-white">
                  {post.title}
                </h2>

                <p className="leading-7 text-slate-300">{post.excerpt}</p>
              </Link>
            ))}
          </div>
        </section>
      </main>
    </>
  );
};

export default BlogIndex;